import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import MuiTextField from '@material-ui/core/TextField';
import { createStyles, withStyles } from '@material-ui/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FontIcon } from '../../FontIcon';
import clamp from 'lodash/clamp';
import merge from 'lodash/merge';
const styles = (theme) => createStyles({
    root: {},
    label: {
        color: 'currentColor',
        fontWeight: theme.font.weight.normal,
    },
    suffix: {
        fontSize: theme.font.size.mediumSmall,
        color: 'currentColor',
        opacity: 0.58,
        marginLeft: 5,
        whiteSpace: 'nowrap',
    },
});
const NumberInput = (props) => {
    const { classes, handleBlur, input, testId = 'NumberInput', InputLabelProps: InputLabelProperties = {}, inputProps, InputProps: InputProperties = {}, max, meta: { touched, error, invalid } = { touched: false, error: false, invalid: false }, min, normalizeOnBlur, postLabel, removable = false, step = 'any', ...otherProps } = props;
    const { value } = props;
    const handleClear = React.useCallback(() => {
        if (input) {
            input.onChange('');
        }
    }, [input]);
    const handleOnKeyDown = React.useCallback((e) => {
        const inputValue = value || (input && input.value);
        if (e.keyCode === 69 || (e.keyCode === 189 && inputValue)) {
            return e.preventDefault();
        }
    }, [input, value]);
    return (React.createElement(MuiTextField, Object.assign({ "data-testid": `${testId}`, inputProps: merge({ step, min, max }, input, { onBlur: handleBlur, onKeyDown: handleOnKeyDown }, inputProps), type: "number", error: touched && invalid, helperText: touched && error, InputLabelProps: merge({ shrink: true, classes: { root: classes.label } }, InputLabelProperties), InputProps: merge({
            endAdornment: (postLabel || (removable && (value || (input && input.value)))) && (React.createElement(InputAdornment, { classes: {
                    root: classes.suffix,
                }, disableTypography: true, position: "end" }, removable ? (React.createElement(FontIcon, { "data-testid": `${testId}-cancel`, color: "currentColor", iconName: "close", onClick: handleClear })) : (postLabel))),
        }, InputProperties) }, otherProps)));
};
const ComposedNumberInput = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    handleBlur: (props) => (event) => {
        const input = event.target;
        const v = parseFloat(input.value);
        const hasMin = typeof props.min !== 'undefined';
        const hasMax = typeof props.max !== 'undefined';
        const hasRange = hasMin || hasMax;
        if (!isNaN(v) && isFinite(v) && hasRange) {
            const min = hasMin ? props.min : -Infinity;
            const max = hasMax ? props.max : Infinity;
            if (v < min || v > max) {
                input.value = clamp(v, min, max).toString();
            }
        }
        if (input.validity.badInput ||
            input.validity.customError ||
            input.validity.patternMismatch ||
            input.validity.rangeOverflow ||
            input.validity.rangeUnderflow ||
            input.validity.tooLong ||
            input.validity.tooShort ||
            input.validity.typeMismatch ||
            input.validity.valueMissing) {
            input.value = '';
        }
        if (props.normalizeOnBlur) {
            input.value = props.normalizeOnBlur(input.value);
        }
        if (props.input && props.input.onBlur) {
            props.input.onBlur(event);
        }
    },
}))(NumberInput);
ComposedNumberInput.displayName = 'NumberInput';
export default ComposedNumberInput;
//# sourceMappingURL=NumberInput.js.map